import { z } from "zod";

export const getPartnerAgreementPdfParamsSchema = z.object({
  document_key: z.string().min(1),
  partnerID: z.string().min(1),
  accessToken: z.string(),
});

export type TGetPartnerAgreementPdfParams = z.infer<
  typeof getPartnerAgreementPdfParamsSchema
>;
